export interface AgreementModel {
    AgreementName: string;
    AgreementPriceName: string;
    ClubName: string;
    BillingCycleId: number;
    BillingMethod: BillingMethod;
    AgreementMonths: number;
    AgreementDays: number;
    AgreementId: number;
    AgreementPriceId: number;
    ClubId: number;
    RenewalMembershipPriceOption: boolean;
}

export interface AgreementPriceModel {
    [key: string]: any;
    ReferenceId: number;
    PriceRequestGroupId: number;
    RefAgreementPriceId: number;
    StartDate: Date;
    FirstBillDate: Date;
    EndDate: Date;
    FinalBillDate: Date;
    MCD: number;
    BillingMethodId: number;
    BillingCycleId: number;
    AutoBill: boolean;

    MembershipFeeResponses: MembershipFeeResponse[];
}

export interface MembershipFeeResponse {
    ReferenceId: number;
    FeeId: number;
    PriceRequestId: number;
    InventoryId: number;
    ClubId: number;
    RefGLAccountId: number;
    Quantity: number;
    NetAmount: number;
    TaxAmount: number;
    DiscountAmount: number;
    SurchargeAmount: number;
    DisplayPrice: number;
    GLProcessTypeId: number;
    FeeName: string;
    BillingAmount: number;

    MembershipTaxResponses: TaxLine[];
    MembershipDiscountResponses: DiscountLine[];
    MembershipSurchargeResponses: SurchargeLine[];
}

export interface TaxLine {
    TaxCategoryPrintName: string;
    TaxAmount: number;
    IsGross: boolean;
}

export interface DiscountLine {
    DiscountName: string;
    DiscountAmount: number;
}

export interface SurchargeLine {
    SurchargeAmount: number;
}

export class FeeLine {
    Name: string;
    Fee: number;
}

export enum BillingMethod {
    Direct_Debit = 1,
    Pay_In_Full = 8
}